import { styled } from '@mui/material'

const SelectorBody = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	flexGrow: 1
})

export default SelectorBody